import React, { useEffect, useState } from 'react';

/**
 * Yataş Grubu · Glowy Studio çerçeve üretimi teklifi.
 * Route: /r/glowy-studio-teklif (sidebar YOK, tam ekran slayt gösterisi)
 *
 * 8 slayt, 16:9, iki marka (Yataş Bedding + Puffy) TEK sunumda.
 * 🔴 Marka başına ayrı sayfa YAPMA: 31 Ağu 2026'da ikisi bilerek birleştirildi
 * ve sunum 16 slayttan 8'e indirildi.
 *
 * Yeniden üretmek için:
 *   node src/pages/glowy-studio-teklif/build.js && node src/pages/glowy-studio-teklif/pdf.js
 *
 * 🔑 "PDF indir" düğmesi belgenin İÇİNDE. iframe dışından Ctrl+P slaytları
 * tek sayfaya kırpar; düğmeyi dışarı taşıma. iframe'e sandbox EKLEME, indirme kırılır.
 *
 * HTML modülü ~50KB, ana bundle'da işi yok: dinamik import ile yükleniyor.
 */
const YUKLE = () => import('./glowyStudioTeklifHtml');

export default function GlowyStudioTeklif() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    YUKLE()
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#1d1d1f">Sunum yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini sunumun kendi zemini (--deck) ile aynı, açılışta flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F0F0F2' }} />;

  return <iframe title="Yataş Grubu · Glowy Studio Çerçeve Teklifi" srcDoc={html} style={fill} />;
}
